/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TopupPrepaidByBankingReferenceTransaction
 */
export interface TopupPrepaidByBankingReferenceTransaction {
    /**
     * 
     * @type {string}
     * @memberof TopupPrepaidByBankingReferenceTransaction
     */
    bankingReference?: string;
    /**
     * 
     * @type {string}
     * @memberof TopupPrepaidByBankingReferenceTransaction
     */
    prepaidAccountId?: string;
    /**
     * 
     * @type {number}
     * @memberof TopupPrepaidByBankingReferenceTransaction
     */
    feeAmount?: number;
}

/**
 * Check if a given object implements the TopupPrepaidByBankingReferenceTransaction interface.
 */
export function instanceOfTopupPrepaidByBankingReferenceTransaction(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TopupPrepaidByBankingReferenceTransactionFromJSON(json: any): TopupPrepaidByBankingReferenceTransaction {
    return TopupPrepaidByBankingReferenceTransactionFromJSONTyped(json, false);
}

export function TopupPrepaidByBankingReferenceTransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TopupPrepaidByBankingReferenceTransaction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bankingReference': !exists(json, 'bankingReference') ? undefined : json['bankingReference'],
        'prepaidAccountId': !exists(json, 'prepaidAccountId') ? undefined : json['prepaidAccountId'],
        'feeAmount': !exists(json, 'feeAmount') ? undefined : json['feeAmount'],
    };
}

export function TopupPrepaidByBankingReferenceTransactionToJSON(value?: TopupPrepaidByBankingReferenceTransaction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bankingReference': value.bankingReference,
        'prepaidAccountId': value.prepaidAccountId,
        'feeAmount': value.feeAmount,
    };
}

